import { getTg } from './telegram.js';
import type { ApiResponse } from '../types/api.js';

export type { ApiResponse } from '../types/api.js';

export function getTelegramInitData(): string {
  const t = getTg();
  return t?.initData ? String(t.initData).trim() : '';
}

export function apiAuthHeaders(extra?: HeadersInit): Record<string, string> {
  const headers: Record<string, string> = {};
  if (extra instanceof Headers) {
    extra.forEach((value, key) => {
      headers[key] = value;
    });
  } else if (Array.isArray(extra)) {
    for (const [key, value] of extra) {
      headers[key] = value;
    }
  } else if (extra && typeof extra === 'object') {
    Object.assign(headers, extra);
  }
  const initData = getTelegramInitData();
  if (initData) headers['X-Telegram-Init-Data'] = initData;
  return headers;
}

export function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  return fetch(url, {
    ...options,
    headers: apiAuthHeaders(options.headers)
  });
}

export async function apiFetchJSON<T = unknown>(url: string, options: RequestInit = {}): Promise<T> {
  const r = await apiFetch(url, options);
  return r.json() as Promise<T>;
}

export async function apiFetchApiResponse(url: string, options: RequestInit = {}): Promise<ApiResponse> {
  return apiFetchJSON<ApiResponse>(url, options);
}

export function ownerChatPhotoSrc(photoUrl: string | null | undefined): string {
  return String(photoUrl || '');
}

const authedImageBlobCache = new Map<string, string>();

/** Load protected image via auth header (no initData in URL). */
export async function resolveAuthedImageSrc(photoUrl: string | null | undefined): Promise<string> {
  const url = String(photoUrl || '');
  if (!url || url.startsWith('blob:') || url.startsWith('data:')) return url;
  const cached = authedImageBlobCache.get(url);
  if (cached) return cached;
  try {
    const res = await apiFetch(url);
    if (!res.ok) return url;
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    authedImageBlobCache.set(url, blobUrl);
    return blobUrl;
  } catch {
    return url;
  }
}
